import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { conversation } from '../mockData/conversation-data';

const ConversationsApi = [
  rest.get(`${API_ROOT}conversations/`, (req, res, ctx) => {
    const messageLimit = req.url.searchParams.get('messageLimit');
    if (messageLimit === '1') {
      return res(ctx.json(conversation));
    }
    return res(ctx.json({ data: [] }));
  }),
  rest.get(`${API_ROOT}conversations/200`, (req, res, ctx) => {
    const patientId = req.url.searchParams.get('patientId');
    if (patientId) {
      return res(ctx.json(conversation));
    }
    return res(ctx.json({ data: [] }));
  }),
];
export default ConversationsApi;
